export function AppLogo() {
  return (
    <>
      <div
        className="flex h-9 w-8 items-center justify-center [clip-path:polygon(8%_0%,92%_0%,100%_8%,100%_85%,50%_100%,0%_85%,0%_8%)]"
        style={{
          background:
            "linear-gradient(180deg, oklch(0.52 0.23 28), oklch(0.38 0.18 28))",
        }}
      >
        <span
          className="font-display -mt-1 text-xl font-bold"
          style={{
            color: "var(--primary-foreground)",
            textShadow: "0 1px 2px oklch(0 0 0 / 0.5)",
          }}
        >
          N
        </span>
      </div>

      <span
        className="font-display text-lg font-bold tracking-[0.15em] uppercase"
        style={{
          color: "var(--accent)",
          textShadow:
            "0 0 8px oklch(0.85 0.28 85 / 0.4), 0 0 16px oklch(0.85 0.28 85 / 0.2)",
        }}
      >
        Nuffle Club
      </span>
    </>
  )
}
